var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileCombustionH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.847 27.518 4.85-8.487A8 8 0 0 1 21.643 15h16.714a8 8 0 0 1 6.943 4.031l4.755 8.32a4 4 0 0 0 2.815 1.961l3.442.574A8 8 0 0 1 63 37.777V41a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-6.877a4 4 0 0 1 3.03-3.88l3.314-.829a4 4 0 0 0 2.503-1.896Z",
    style: {
      fill: "#ff938d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 42H14.877A10.877 10.877 0 0 1 4 31.123a3.966 3.966 0 0 1 .116-.9l-.085.021A4 4 0 0 0 1 34.123V41a4 4 0 0 0 4 4h54a4 4 0 0 0 3.892-3.108A3.974 3.974 0 0 1 62 42Z",
    style: {
      fill: "#f27875"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 34.12V37h3l1-4H1.16A4.152 4.152 0 0 0 1 34.12Z",
    style: {
      fill: "#a7d0e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.591 34.636A10.715 10.715 0 0 1 4.173 33h-3a3.974 3.974 0 0 0-.075.29c-.015.07-.034.14-.045.211a4.005 4.005 0 0 0-.053.622V37h3Z",
    style: {
      fill: "#80bbce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.735 18H32v10h15l-4.835-8.058A4 4 0 0 0 38.735 18Z",
    style: {
      fill: "#a7d0e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.069 23a1 1 0 0 1-.859-.485l-.617-1.03a1 1 0 0 1 1.715-1.029l.617 1.029A1 1 0 0 1 41.069 23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 21v-3h-3v10h15l-1.8-3H39a4 4 0 0 1-4-4Z",
    style: {
      fill: "#80bbce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 28h15V18h-6.735a4 4 0 0 0-3.43 1.942Z",
    style: {
      fill: "#a7d0e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.635 18.942 22.2 18h-.935a4 4 0 0 0-3.43 1.942L13 28h15v-3h-2.935a4 4 0 0 1-3.43-6.058Z",
    style: {
      fill: "#80bbce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 33a3.995 3.995 0 0 0 4 4h1.96a7.8 7.8 0 0 0-1.56-4Z",
    style: {
      fill: "#a7d0e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 44a6 6 0 1 0-11.91 1h11.82a6 6 0 0 0 .09-1Z",
    style: {
      fill: "#f27875"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 43,
    r: 6,
    style: {
      fill: "#7a838b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 43,
    r: 2,
    style: {
      fill: "#a7d0e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 43,
    r: 6,
    style: {
      fill: "#7a838b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 46a5.993 5.993 0 0 1-5.466-8.466 6 6 0 1 0 7.932 7.932A5.974 5.974 0 0 1 18 46ZM51.867 46a5.993 5.993 0 0 1-5.467-8.466 6 6 0 1 0 7.932 7.932 5.974 5.974 0 0 1-2.465.534Z",
    style: {
      fill: "#5d6972"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 43,
    r: 2,
    style: {
      fill: "#a7d0e1"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.48 28.9-3.443-.573a2.99 2.99 0 0 1-2.111-1.471l-4.755-8.32A9.019 9.019 0 0 0 38.357 14H21.643a9.019 9.019 0 0 0-7.814 4.535l-4.85 8.487A3.016 3.016 0 0 1 7.1 28.444l-3.314.828A4.985 4.985 0 0 0 .245 32.6c-.011.026-.012.057-.021.084A4.98 4.98 0 0 0 0 34.123V41a5.006 5.006 0 0 0 5 5h3.685a6.985 6.985 0 0 0 12.63 0h21.37a6.985 6.985 0 0 0 12.63 0H59a5.006 5.006 0 0 0 5-5v-3.223a8.973 8.973 0 0 0-7.52-8.877Zm4.414 5.1a6.976 6.976 0 0 1 .877 2H61a3.01 3.01 0 0 1-2.118-.872 3.057 3.057 0 0 1-.71-1.128ZM2.01 34h1.709l-.5 2H2v-1.877c0-.042.009-.082.01-.123ZM15 48a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Zm34 0a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Zm10-4h-3.08a7 7 0 1 0-13.84 0H21.92a7 7 0 1 0-13.84 0H5a3 3 0 0 1-3-3v-3h2a1 1 0 0 0 .97-.757l1-4A1 1 0 0 0 5 32H2.889a2.983 2.983 0 0 1 1.383-.787l3.315-.829a5.026 5.026 0 0 0 3.128-2.37l4.85-8.487A7.016 7.016 0 0 1 21.643 16h16.714a7.016 7.016 0 0 1 6.078 3.527l4.754 8.32a4.98 4.98 0 0 0 3.519 2.453l3.443.574A7.013 7.013 0 0 1 58.959 32H57a1 1 0 0 0-1 1 4.995 4.995 0 0 0 5 5h1v3a3 3 0 0 1-3 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.458 23.485a1 1 0 0 0-1.715 1.03L45.234 27H33v-8h5.735a3.015 3.015 0 0 1 2.573 1.457l.634 1.058a1 1 0 0 0 1.715-1.03l-.635-1.058A5.023 5.023 0 0 0 38.735 17H32a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h15a1 1 0 0 0 .857-1.515ZM28 17h-6.735a5.023 5.023 0 0 0-4.287 2.427l-4.835 8.058A1 1 0 0 0 13 29h15a1 1 0 0 0 1-1V18a1 1 0 0 0-1-1Zm-1 10H14.766l3.926-6.543A3.015 3.015 0 0 1 21.265 19H27ZM34 30h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2ZM15 30h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2ZM49 40a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM15 40a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCombustionH);
export default __webpack_public_path__ + "static/media/MobileCombustion-h.a2e8268ae7dd73408e11451b56555b31.svg";
export { ForwardRef as ReactComponent };